import { render, staticRenderFns } from "./VendasUltimosMeses.vue?vue&type=template&id=290316d1&scoped=true"
import script from "./VendasUltimosMeses.vue?vue&type=script&lang=js"
export * from "./VendasUltimosMeses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290316d1",
  null
  
)

export default component.exports